import React from 'react';
import Skeleton from './Skeleton';

/**
 * SettingsSkeleton
 * Shimmer placeholder for the Settings page:
 *   - sticky profile card (left) + form cards (right)
 * Built from the base <Skeleton /> block (pure Tailwind shimmer).
 */

const CARD =
  'bg-white dark:bg-[#262b33] rounded-[20px] border border-[#E3E9F3] dark:border-gray-800 shadow-[0_1px_2px_rgba(15,23,42,0.05),0_4px_10px_-3px_rgba(15,23,42,0.06)]';

const S = Skeleton;

const FieldSkeleton = () => (
  <div>
    <S className="h-3 w-24 rounded-md mb-2" />
    <S className="h-11 w-full rounded-xl" />
  </div>
);

const SettingsSkeleton = () => (
  <div className="w-full max-w-[1040px] mx-auto pb-10">
    {/* Header */}
    <div className="mb-6">
      <S className="h-7 w-40 rounded-xl" />
      <S className="h-3.5 w-96 max-w-full rounded-md mt-3" />
    </div>

    <div className="grid grid-cols-1 lg:grid-cols-[320px_minmax(0,1fr)] gap-5">
      {/* Left profile card */}
      <div className={`${CARD} p-6 flex flex-col items-center text-center`}>
        <S className="w-24 h-24 rounded-2xl" />
        <S className="h-5 w-32 rounded-md mt-4" />
        <S className="h-3 w-20 rounded-md mt-2" />
        <S className="h-6 w-28 rounded-lg mt-3" />
        <div className="w-full mt-6 space-y-3">
          <S className="h-14 w-full rounded-2xl" />
          <S className="h-14 w-full rounded-2xl" />
        </div>
      </div>

      {/* Right forms */}
      <div className="space-y-5">
        <div className={`${CARD} p-6`}>
          <S className="h-4 w-32 rounded-md" />
          <S className="h-3 w-64 max-w-full rounded-md mt-2 mb-5" />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <FieldSkeleton />
            <FieldSkeleton />
            <FieldSkeleton />
            <FieldSkeleton />
          </div>
          <div className="flex justify-end pt-5 mt-5 border-t border-[#EEF2F8] dark:border-gray-800">
            <S className="h-10 w-32 rounded-xl" />
          </div>
        </div>

        <div className={`${CARD} p-6`}>
          <S className="h-4 w-28 rounded-md" />
          <S className="h-3 w-72 max-w-full rounded-md mt-2 mb-5" />
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <FieldSkeleton />
            <FieldSkeleton />
            <FieldSkeleton />
          </div>
          <div className="flex justify-end pt-5 mt-5 border-t border-[#EEF2F8] dark:border-gray-800">
            <S className="h-10 w-36 rounded-xl" />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default SettingsSkeleton;
